import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PendingActionsPanel({
    pendingActions,
    onCancel,
    onExecuteNow,
    containerStyle,
    rowButtonGhostStyle,
    rowButtonDangerStyle,
    title
}) {
    const { t } = useTranslation('messages');
    const resolvedTitle = title ?? t('pendingActionsTitle');

    if (!pendingActions || pendingActions.length === 0) return null;

    const defaultContainer = {
        background: '#fffbeb',
        border: '1px solid #fde68a',
        borderRadius: '10px',
        padding: '10px',
        marginBottom: '12px'
    };
    const ghostBtn = rowButtonGhostStyle || {
        border: '1px solid #ddd', borderRadius: '8px', background: 'white', padding: '6px 10px', cursor: 'pointer'
    };
    const dangerBtn = rowButtonDangerStyle || {
        border: 'none', borderRadius: '8px', background: '#b91c1c', color: 'white', padding: '6px 10px', cursor: 'pointer'
    };

    return (
        <div style={{ ...defaultContainer, ...(containerStyle || {}) }}>
            <div style={{ fontWeight: 700, marginBottom: '6px' }}>{resolvedTitle}</div>
            <div style={{ display: 'grid', gap: '6px' }}>
                {pendingActions.map((item) => (
                    <div
                        key={item.id}
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            border: '1px solid #fef3c7',
                            background: '#fff',
                            borderRadius: '8px',
                            padding: '8px',
                            gap: '8px'
                        }}
                    >
                        <div style={{ fontSize: '13px' }}>{item.label}</div>
                        <div style={{ display: 'flex', gap: '6px' }}>
                            <button type="button" onClick={() => onCancel(item.id)} style={ghostBtn}>{t('cancelPending')}</button>
                            <button type="button" onClick={() => onExecuteNow(item.id)} style={dangerBtn}>{t('executeNow')}</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
